import React, { useEffect, useRef, useState } from "react";
import sia from "../services/Api";
import Cookies from "js-cookie";
import { useLoginDispatch } from "../hooks";
import logo from "../assets/images/logo.svg";
import LoaderView from "../tools/LoaderView";
import { notifyErrorMessage, notifySuccessfulMessage } from "../App";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast, Slide } from 'react-toastify'
import TopNav from "./TopNav";

function Login(props) {
  const loginDispatch = useLoginDispatch();
  const [isLoading, setLoading] = useState(false)
  const [isForgetPassword, setIsForgetPassword] = useState(false)

  const handeLogin = async (e) => {
    setLoading(true)
    e.preventDefault();

    var postBody = {}
    if (isForgetPassword) {
      postBody = {
        phone: e.target.elements.phone.value,
      }
    } else {
      postBody = {
        phone: e.target.elements.phone.value,
        password: e.target.elements.password.value,
      }
    }

    await sia
      .PostDataToServer(isForgetPassword ? '/user/forgetSms' : '/user/login', postBody)
      .then((res) => {
        if (res.status == 200) {
          if (!isForgetPassword) {
            loginDispatch(true);
            localStorage.setItem("token", res.data.token);
            sia.setHeaderForAxios(res.data.token);
            window.location = '/profile-first'
          } else {
            notifySuccessfulMessage('رمز عبور جدید برای شما ارسال شد')
            setIsForgetPassword(false)
          }
        } else {
          notifyErrorMessage('رمز عبور معتبر نیست')
        }

      })
      .catch((err) => {
        console.error(err)
      });
    setLoading(false)
  }

  return (
    <>
      <ToastContainer rtl closeOnClick pauseOnHover position="top-center" transition={Slide} />
      <div className="pagewrapper" id="login-page">
        <div className="blur">
          <div className="container">
            <TopNav isLoginPage={true} />
            {isLoading ? <LoaderView /> : <div className="content">
              <div className="login-wrapper radius50 box-sizing">
                <form
                  action
                  id="login-form"
                  onSubmit={handeLogin}
                  method="post"
                >
                  <p className="text">
                    {isForgetPassword ? 'لطفا شماره همراه خود را وارد نمایید:' : 'لطفا شماره تلفن و رمز عبور را وارد کنید:'}
                  </p>

                  <div className="input-wrapper">
                    <input
                      type="phone"
                      name="phone"
                      placeholder="09*********"
                      defaultValue=""
                      className="login-mobile input radius50 box-sizing"
                    />
                    <label className="label radius50 box-sizing">
                      تلفن همراه
                    </label>
                  </div>
                  {!isForgetPassword && <div className="input-wrapper">
                    <input
                      type="password"
                      name="password"
                      className="login-pswrd input radius50 box-sizing"
                    />
                    <label className="label radius50 box-sizing">
                      رمز ورود
                    </label>
                  </div>}
                  <input
                    type="submit"
                    value={isForgetPassword ? 'دریافت رمز جدید' : 'ارسال'}
                    className="login-btn radius50"
                  />
                  <p onClick={() => window.location = './register'} className="clickable pt-3">حساب کاربری ندارید؟</p>
                  <p onClick={() => setIsForgetPassword(!isForgetPassword)} className="clickable pt-3">{isForgetPassword ? 'ورود' : 'رمز عبور خود را فراموش کرده اید؟'}</p>
                </form>
              </div>
            </div>}
            <div className="top-section-bullets">
              <a href title className="item ease box-sizing" />
              <a href title className="item selected ease box-sizing" />
              <a href title className="item ease box-sizing" />
              <a href title className="item ease box-sizing" />
            </div>
            <div className="clear" />
          </div>
        </div>
      </div>
    </>
  );
}
export default Login;
